import { render, staticRenderFns } from "./VerifyCode.vue?vue&type=template&id=4c3406d1&"
import script from "./VerifyCode.vue?vue&type=script&lang=ts&"
export * from "./VerifyCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports